export const CLASS_NAMES = {
	brandHeader:
		'flex pt-[15px] pb-[15px] w-full items-center border-t-2 border-[var(--color-primary-600)] border-b border-[var(--color-primary-100)] bg-white',
	brandInner: 'mx-auto flex w-full max-w-[960px] items-center gap-4 px-4',
	brandLogo: 'h-6 w-auto max-h-8 object-contain',
	brandName:
		'text-lg font-extrabold leading-none text-[var(--color-primary-800)]',
	brandDivider: 'h-4 w-px bg-[var(--color-primary-100)]'
} as const;
